export default __webpack_public_path__ + "static/media/login_shadow.83f26778.png";